import { Component, Optional } from '@angular/core';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  Util,
  ViewResult,
  ViewState,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import {
  combineLatest,
  filter,
  first,
  map,
  mergeMap,
  Observable,
  tap
} from 'rxjs';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';

@Component({
  selector: 'app-deduplicate-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class DeduplicateActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = combineLatest([
      this.listViewProvider.selectedItems$,
      this.listViewProvider.selectAll$
    ]).pipe(
      map(([selectedItems, selectAll]) => {
        const numberOfSelectedItems = selectedItems.length;

        if (
          numberOfSelectedItems < 2 ||
          numberOfSelectedItems > 15 ||
          selectAll
        ) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.listViewProvider.selectedItems$.pipe(
      first(),
      mergeMap((selectedItems) => {
        const viewState = this.getInitialState(selectedItems);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult) => this.acceptResult(viewResult)),
          tap(() => this.log('result ACCEPTED')),
          map((viewResult) => {
            const selectedDeduplicatedIds = {
              $selectedDeduplicatedIds: selectedItems.map(
                (selectedItem: any) => selectedItem['en~agent~id']
              )
            };
            const itemActionResult = {
              ...viewResult.viewData[0],
              ...selectedDeduplicatedIds
            };
            return new ItemActionResult(EMPTY_ACTION_RESULT, itemActionResult);
          })
        );
      })
    );
  }

  protected getInitialState(selectedItems: object[]): ViewState {
    return Object.assign({
      $selected: Util.mapToBasicItemData(selectedItems)
    });
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      this.getWindowTarget()
    );
    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
